export const CanvasSymbol = Symbol('Canvas')
export const name = 'canvas' as const
